// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfe-beh-smart-groups-select-action {
  width: 196px;
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header-actions {
  display: flex;
  gap: var(--neon-2_15_0-spacing-large);
  margin-block-start: var(--neon-2_15_0-spacing-large);
}

.mfe-beh-smart-groups-table-header-buttons {
  display: flex;
  align-items: flex-end;
}

.mfe-beh-smart-groups-last-setting {
  display: flex;
  align-items: center;
  margin-block-end: 4px;
}

.mfe-beh-smart-groups-line {
  margin-inline: var(--neon-2_15_0-spacing-small);
  width: 1px;
  height: 21px;
}

/* Reset some default table styles */
.mfe-beh-smart-groups-consequence_table table {
  border-collapse: collapse;
  width: 100%;
  background-color: #fff;
}

/* Style table headers */
.mfe-beh-smart-groups-consequence_table th {
  border: none;
}

/* Style even rows */
.mfe-beh-smart-groups-consequence_table tbody tr:nth-child(even) {
  background: none;
}

/* Style odd rows */
.mfe-beh-smart-groups-consequence_table tbody tr:nth-child(odd) {
  background: none;
}

/* Style table cells */
.mfe-beh-smart-groups-consequence_table td {
  border: none;
  text-align: left;
  /* Default horizontal alignment */
  vertical-align: middle;
  /* Default vertical alignment */
}

/* Style checkboxes in the table */
.mfe-beh-smart-groups-consequence_table td input[type=checkbox] {
  margin: 0;
  padding: 0;
}

/* Style table headers with sorting icons */
/* Styling for the sorting icon */
.mfe-beh-smart-groups-consequence_table th .neon-icon {
  margin-left: 5px;
}

/* Remove default list styling for data labels */
.mfe-beh-smart-groups-consequence_table td[data-label]::before {
  content: attr(data-label) ": ";
  display: none;
  /* Hide from visual display */
}

.mfe-beh-smart-groups-planet-all-checkbox-list-parent span {
  position: absolute;
  clip-path: polygon(0 0, 0 0, 0 0);
}

/* Visually hidden class for accessibility */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: polygon(0 0, 0 0, 0 0);
  white-space: nowrap;
  border: 0;
}

/* Screen reader-only text for checkboxes */
.mfe-beh-smart-groups-consequence_table td .visually-hidden {
  display: inline;
}

/* Remove default bullet points for unordered lists */
.mfe-beh-smart-groups-consequence_table ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Style selected rows for better visibility */
.mfe-beh-smart-groups-consequence_table tbody tr.selected {
  color: #fff;
}

/* Style the table container */
.mfe-beh-smart-groups-consequence_table {
  max-width: 100%;
  width: -webkit-fill-available;
  height: calc(100vh - 285px);
  overflow-x: auto;
  margin-top: 16px;
  overflow-y: auto;
}

/* Add hover effect on table rows */
.mfe-beh-smart-groups-consequence_table tbody tr:hover {
  background: none;
}

/* Ensure proper contrast for text */
/* Define specific column widths */
.mfe-beh-smart-groups-consequence_table th:nth-child(1),
.mfe-beh-smart-groups-consequence_table td:nth-child(1) {
  width: 3.87%;
  /* 48px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2),
.mfe-beh-smart-groups-consequence_table td:nth-child(2) {
  width: 18.23%;
  /* 226px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2) div,
.mfe-beh-smart-groups-consequence_table th:nth-child(3) div,
.mfe-beh-smart-groups-consequence_table th:nth-child(7) div {
  width: 100%;
  display: flex;
  align-items: center;
}

.mfe-beh-smart-groups-consequence_table th:nth-child(2) div span,
.mfe-beh-smart-groups-consequence_table th:nth-child(3) div span,
.mfe-beh-smart-groups-consequence_table th:nth-child(7) div span {
  display: flex;
  margin-inline-start: 7px;
  /* Adjust the margin as needed */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(3),
.mfe-beh-smart-groups-consequence_table td:nth-child(3) {
  width: 11.29%;
  /* 140px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(4),
.mfe-beh-smart-groups-consequence_table td:nth-child(4) {
  width: 11.85%;
  /* 147px / 1240px */
  text-align: center;
}

.mfe-beh-smart-groups-consequence_table th:nth-child(5),
.mfe-beh-smart-groups-consequence_table td:nth-child(5) {
  width: 9.68%;
  /* 120px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(6),
.mfe-beh-smart-groups-consequence_table td:nth-child(6) {
  width: 19.52%;
  /* 241px / 1240px */
}

.mfe-beh-smart-groups-consequence_table td:nth-child(6) {
  max-width: 80px;
  /* Adjust this value to control the maximum visible width */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(7),
.mfe-beh-smart-groups-consequence_table td:nth-child(7) {
  width: 14.52%;
  /* 180px / 1240px */
}

.mfe-beh-smart-groups-consequence_table th:nth-child(8),
.mfe-beh-smart-groups-consequence_table td:nth-child(8) {
  width: 11.13%;
  /* 138px / 1240px */
  text-align: center;
}

.mfe-beh-smart-groups-ct_positivity {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.mfe-beh-smart-groups-ct_positivity p {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin: 0px;
}

.mfe-beh-smart-groups-ct_positivity span {
  display: flex;
  width: 114px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: var(--text-color-dark, #333);
  text-align: center;
  color: var(--neon-2_15_0-color-black);
  font: var(--neon-2_15_0-font-1);
}

.mfe-beh-smart-groups-ct_positivity #mfe-beh-smart-groups-consequence_bar-only-example {
  min-width: 150px !important;
}

.mfe-beh-smart-groups-planet-all-checkbox-list-parent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mfe-beh-smart-groups-smart-group-table-error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
}

.mfe-beh-smart-groups-smart-group-table-loader-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.mfe-beh-smart-groups-smart-group-table-empty-state {
  margin-block-start: 50px;
}

.mfe-beh-smart-groups-pagination-parent {
  background-color: #fff;
  margin-top: 5px;
}

.mfe-beh-smart-groups-system-message-container {
  width: 100%;
  margin-top: 9px;
  margin-bottom: -9px;
}

.mfe-beh-smart-groups-system-message-action {
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./components/smart-groups/smart-group-table/smart-group-table.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,qCAAA;EACA,oDAAA;AACJ;;AAEA;EACI,aAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,+CAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAGA,oCAAA;AACA;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;AAAJ;;AAGA,wBAAA;AACA;EAGI,YAAA;AAFJ;;AAKA,oBAAA;AACA;EACI,gBAAA;AAFJ;;AAKA,mBAAA;AACA;EACI,gBAAA;AAFJ;;AAKA,sBAAA;AACA;EAEI,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,sBAAA;EACA,+BAAA;AAHJ;;AAMA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;AAHJ;;AAQA,2CAAA;AAMA,iCAAA;AACA;EACI,gBAAA;AAVJ;;AAaA,gDAAA;AACA;EACI,8BAAA;EACA,aAAA;EACA,6BAAA;AAVJ;;AAgBA;EACI,kBAAA;EACA,iCAAA;AAbJ;;AAgBA,4CAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,SAAA;AAbJ;;AAgBA,2CAAA;AACA;EACI,eAAA;AAbJ;;AAgBA,qDAAA;AACA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AAbJ;;AAgBA,8CAAA;AACA;EAEI,WAAA;AAdJ;;AAiBA,8BAAA;AACA;EACI,eAAA;EACA,6BAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;;AAiBA,mCAAA;AACA;EACI,gBAAA;AAdJ;;AAiBA,oCAAA;AAMA,kCAAA;AACA;;EAEI,YAAA;EACA,kBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;;EAGI,WAAA;EACA,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;;EAGI,aAAA;EACA,wBAAA;EACA,gCAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;;AAsBA;;EAEI,YAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,eAAA;EACA,2DAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;AAnBJ;;AAsBA;;EAEI,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAnBJ;;AAsBA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;AAnBJ;;AAqBA;EACI,2BAAA;AAlBJ;;AAoBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBJ;;AAmBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAhBJ;;AAkBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAfJ;;AAkBA;EACI,wBAAA;AAfJ;;AAkBA;EACI,sBAAA;EACA,eAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AAfJ;;AAkBA;EACI,UAAA;AAfJ","sourcesContent":[".__mfe__select-action {\r\n    width: 196px;\r\n    margin-block-start: var(--__neon__spacing-large);\r\n}\r\n\r\n.__mfe__table-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-end;\r\n    margin-block-start: var(--__neon__spacing-large);\r\n}\r\n\r\n.__mfe__table-header-actions {\r\n    display: flex;\r\n    gap: var(--__neon__spacing-large);\r\n    margin-block-start: var(--__neon__spacing-large);\r\n}\r\n\r\n.__mfe__table-header-buttons {\r\n    display: flex;\r\n    align-items: flex-end;\r\n}\r\n\r\n.__mfe__last-setting {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-block-end: 4px;\r\n}\r\n\r\n.__mfe__line {\r\n    margin-inline: var(--__neon__spacing-small);\r\n    width: 1px;\r\n    height: 21px;\r\n}\r\n\r\n// css by Abhinav\r\n/* Reset some default table styles */\r\n.__mfe__consequence_table table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    background-color: #fff;\r\n}\r\n\r\n/* Style table headers */\r\n.__mfe__consequence_table th {\r\n    // text-align: left;\r\n    // padding: 10px;\r\n    border: none;\r\n}\r\n\r\n/* Style even rows */\r\n.__mfe__consequence_table tbody tr:nth-child(even) {\r\n    background: none;\r\n}\r\n\r\n/* Style odd rows */\r\n.__mfe__consequence_table tbody tr:nth-child(odd) {\r\n    background: none;\r\n}\r\n\r\n/* Style table cells */\r\n.__mfe__consequence_table td {\r\n    // padding: 10px;\r\n    border: none;\r\n    text-align: left;\r\n    /* Default horizontal alignment */\r\n    vertical-align: middle;\r\n    /* Default vertical alignment */\r\n}\r\n\r\n/* Style checkboxes in the table */\r\n.__mfe__consequence_table td input[type=\"checkbox\"] {\r\n    margin: 0;\r\n    padding: 0;\r\n    // width: 16px;\r\n    // height: 16px;\r\n}\r\n\r\n/* Style table headers with sorting icons */\r\n// .__mfe__consequence_table th span {\r\n//     display: flex;\r\n//     align-items: center;\r\n// }\r\n\r\n/* Styling for the sorting icon */\r\n.__mfe__consequence_table th .neon-icon {\r\n    margin-left: 5px;\r\n}\r\n\r\n/* Remove default list styling for data labels */\r\n.__mfe__consequence_table td[data-label]::before {\r\n    content: attr(data-label) \": \";\r\n    display: none;\r\n    /* Hide from visual display */\r\n}\r\n\r\n// Visually hidding the table checkbox label \r\n// so that it is not visible on webpage \r\n// but readable by Narrator for accessibility\r\n.__mfe__planet-all-checkbox-list-parent span {\r\n    position: absolute;\r\n    clip-path: polygon(0 0, 0 0, 0 0);\r\n}\r\n\r\n/* Visually hidden class for accessibility */\r\n.visually-hidden {\r\n    position: absolute;\r\n    width: 1px;\r\n    height: 1px;\r\n    padding: 0;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    clip-path: polygon(0 0, 0 0, 0 0);\r\n    white-space: nowrap;\r\n    border: 0;\r\n}\r\n\r\n/* Screen reader-only text for checkboxes */\r\n.__mfe__consequence_table td .visually-hidden {\r\n    display: inline;\r\n}\r\n\r\n/* Remove default bullet points for unordered lists */\r\n.__mfe__consequence_table ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n/* Style selected rows for better visibility */\r\n.__mfe__consequence_table tbody tr.selected {\r\n    // background-color: #007bff;\r\n    color: #fff;\r\n}\r\n\r\n/* Style the table container */\r\n.__mfe__consequence_table {\r\n    max-width: 100%;\r\n    width: -webkit-fill-available;\r\n    height: calc(100vh - 285px);\r\n    overflow-x: auto;\r\n    margin-top: 16px;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* Add hover effect on table rows */\r\n.__mfe__consequence_table tbody tr:hover {\r\n    background: none;\r\n}\r\n\r\n/* Ensure proper contrast for text */\r\n// .__mfe__consequence_table th,\r\n// .__mfe__consequence_table td {\r\n//     color: #333;\r\n// }\r\n\r\n/* Define specific column widths */\r\n.__mfe__consequence_table th:nth-child(1),\r\n.__mfe__consequence_table td:nth-child(1) {\r\n    width: 3.87%;\r\n    /* 48px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(2),\r\n.__mfe__consequence_table td:nth-child(2) {\r\n    width: 18.23%;\r\n    /* 226px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(2) div,\r\n.__mfe__consequence_table th:nth-child(3) div,\r\n.__mfe__consequence_table th:nth-child(7) div {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(2) div span,\r\n.__mfe__consequence_table th:nth-child(3) div span,\r\n.__mfe__consequence_table th:nth-child(7) div span {\r\n    display: flex;\r\n    margin-inline-start: 7px;\r\n    /* Adjust the margin as needed */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(3),\r\n.__mfe__consequence_table td:nth-child(3) {\r\n    width: 11.29%;\r\n    /* 140px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(4),\r\n.__mfe__consequence_table td:nth-child(4) {\r\n    width: 11.85%;\r\n    /* 147px / 1240px */\r\n    text-align: center;\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(5),\r\n.__mfe__consequence_table td:nth-child(5) {\r\n    width: 9.68%;\r\n    /* 120px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(6),\r\n.__mfe__consequence_table td:nth-child(6) {\r\n    width: 19.52%;\r\n    /* 241px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table td:nth-child(6) {\r\n    max-width: 80px;\r\n    /* Adjust this value to control the maximum visible width */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(7),\r\n.__mfe__consequence_table td:nth-child(7) {\r\n    width: 14.52%;\r\n    /* 180px / 1240px */\r\n}\r\n\r\n.__mfe__consequence_table th:nth-child(8),\r\n.__mfe__consequence_table td:nth-child(8) {\r\n    width: 11.13%;\r\n    /* 138px / 1240px */\r\n    text-align: center;\r\n}\r\n\r\n.__mfe__ct_positivity {\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.__mfe__ct_positivity p {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    align-self: stretch;\r\n    margin: 0px;\r\n}\r\n\r\n.__mfe__ct_positivity span {\r\n    display: flex;\r\n    width: 114px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 10px;\r\n    color: var(--text-color-dark, #333);\r\n    text-align: center;\r\n    color: var(--__neon__color-black);\r\n    font: var(--__neon__font-1);\r\n}\r\n.__mfe__ct_positivity #__mfe__consequence_bar-only-example{\r\n    min-width:150px !important;\r\n}\r\n.__mfe__planet-all-checkbox-list-parent{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.__mfe__smart-group-table-error-state{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 80px;\r\n}\r\n.__mfe__smart-group-table-loader-state{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 120px;\r\n}\r\n\r\n.__mfe__smart-group-table-empty-state{\r\n    margin-block-start: 50px;\r\n}\r\n\r\n.__mfe__pagination-parent{\r\n    background-color: #fff;\r\n    margin-top: 5px;\r\n}\r\n\r\n.__mfe__system-message-container{\r\n    width:100%;\r\n    margin-top: 9px;\r\n    margin-bottom: -9px;\r\n}\r\n\r\n.__mfe__system-message-action{\r\n    width:70%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
